/* Supplement Advisor — hermano del constructor de protocolo.

   Cuatro preguntas -> de dos a cuatro suplementos, con que es cada uno, para que
   sirve y por que te toco a ti. Reutiliza el CSS y la mecanica de tts-regimen.

   DE DONDE SALE EL COPY, Y POR QUE NO DE LA FICHA DE PRODUCTO
   Las descripciones que vienen del proveedor dicen cosas como "enhancing insulin
   sensitivity", "reduce inflammation", "prevent clogged pores", "speed healing of
   skin tissue" o "aids in removal of toxins". Eso es lenguaje de medicamento y no
   puede salir de aqui. El copy de este fichero esta escrito sobre la guia de Kari
   (TTS_Clinical_Client_Supplement_Guide_Benefit_Focused), que usa "apoyo",
   "complementa" y "explora", y sobre los bloques supp* que ya existen en
   tts-regimen.js. Los ingredientes SI salen de la etiqueta real.

   NO SE PREGUNTA POR SALUD. Solo por objetivo, formato y preferencias. En cuanto
   se pregunta "tienes acne" o "tienes el higado cargado" esto deja de ser una
   guia de producto y empieza a parecer un consejo clinico, que no es.
*/

var S = {
  fulvic:{h:"fulvic-cellular-repair-complex",n:"Fulvic Cellular Repair Complex",f:{es:"90 cápsulas",en:"90 capsules"},p:65,
    q:{es:"Minerales fúlvicos de suelos antiguos, con aminoácidos y oligoelementos.",en:"Fulvic minerals from ancient soils, with amino acids and trace elements."},
    w:{es:"La base mineral. Los minerales participan en el metabolismo celular normal y en la función enzimática.",en:"The mineral foundation. Minerals take part in normal cellular metabolism and enzyme function."}},
  hsn:{h:"h-s-n-hair-skin-and-nails-essentials",n:"H.S.N. Essentials",f:{es:"cápsulas",en:"capsules"},p:30,
    q:{es:"Biotina, vitamina C, zinc y vitaminas A y E, con extractos de cola de caballo y bambú.",en:"Biotin, vitamin C, zinc and vitamins A and E, with horsetail and bamboo extracts."},
    w:{es:"Los micronutrientes de pelo, piel y uñas, en una sola toma diaria.",en:"The hair, skin and nail micronutrients, in a single daily dose."}},
  greens:{h:"skingreens-superfood",n:"SkinGreens Superfood",f:{es:"polvo",en:"powder"},p:30,
    w:{es:"Variedad vegetal concentrada para un día con prisa.",en:"Concentrated plant variety for a day in a hurry."},
    q:{es:"Hierba de cebada, espirulina, té verde, remolacha, açaí y cúrcuma.",en:"Barley grass, spirulina, green tea, beet, açaí and turmeric."}},
  blemish:{h:"blemish-repair-complex-1",n:"Blemish Repair Complex",f:{es:"90 cápsulas",en:"90 capsules"},p:65,
    q:{es:"Vitaminas A, E y complejo B, zinc, cobre, selenio, NAC, astrágalo y ginseng.",en:"Vitamins A, E and B complex, zinc, copper, selenium, NAC, astragalus and ginseng."},
    w:{es:"La fórmula oral para quien quiere apoyar el aspecto de una piel desigual.",en:"The oral formula for skin that tends to look uneven."}},
  colbuild:{h:"collagen-building-complex-90-capsules",n:"Collagen Building Complex",f:{es:"90 cápsulas",en:"90 capsules"},p:65,
    q:{es:"Vitamina C, ácido hialurónico y aminoácidos esenciales.",en:"Vitamin C, hyaluronic acid and essential amino acids."},
    w:{es:"Los cofactores nutricionales que intervienen en la formación normal de colágeno.",en:"The nutritional cofactors involved in normal collagen formation."}},
  colrec:{h:"collagen-recovery-complex-1",n:"Collagen Recovery Complex",f:{es:"90 cápsulas",en:"90 capsules"},p:65,
    q:{es:"Varios tipos de colágeno con vitamina C, minerales y ácido hialurónico.",en:"Several collagen types with vitamin C, minerals and hyaluronic acid."},
    w:{es:"Si prefieres una sola fórmula en vez de combinar dos.",en:"If you would rather take one formula than combine two."}},
  peptides:{h:"grass-fed-collagen-building-peptides",n:"Grass-Fed Collagen Building Peptides",f:{es:"polvo",en:"powder"},p:60,
    q:{es:"Colágeno hidrolizado tipos 1 y 3, rico en glicina, prolina e hidroxiprolina.",en:"Hydrolysed collagen types 1 and 3, rich in glycine, proline and hydroxyproline."},
    w:{es:"Colágeno como hábito diario: se disuelve en el café o en el batido.",en:"Collagen as a daily habit: dissolves into coffee or a smoothie."}},
  glyco:{h:"glycodefence-anti-glycation-support",n:"GlycoDefence",f:{es:"cápsulas",en:"capsules"},p:25,
    q:{es:"Vitaminas C y E, biotina, magnesio, zinc, y extractos de melón amargo, canela y gymnema.",en:"Vitamins C and E, biotin, magnesium, zinc, and bitter melon, cinnamon and gymnema extracts."},
    w:{es:"La glicación entrecruza el colágeno y es una de las vías del envejecimiento de la piel.",en:"Glycation cross-links collagen and is one of the pathways of skin ageing."}},
  resv:{h:"timeless-skin-resveratrol-50-600mg",n:"Timeless Skin · Resveratrol",f:{es:"600 mg, cápsulas",en:"600 mg, capsules"},p:25,
    q:{es:"Trans-resveratrol al 50%, de raíz de Polygonum cuspidatum.",en:"50% trans-resveratrol, from Polygonum cuspidatum root."},
    w:{es:"Un polifenol vegetal estudiado por su actividad antioxidante.",en:"A plant polyphenol studied for antioxidant activity."}},
  biome:{h:"beauty-biome",n:"Beauty Biome",f:{es:"cápsulas",en:"capsules"},p:25,
    q:{es:"Vinagre de manzana 1.000 mg, inulina 200 mg, DigeZyme 100 mg y L. acidophilus LA85, 1.000 millones de UFC.",en:"Apple cider vinegar 1,000 mg, inulin 200 mg, DigeZyme 100 mg and L. acidophilus LA85, 1 billion CFU."},
    w:{es:"Piensa en DIGESTIÓN: enzimas que ayudan a descomponer los alimentos, con fibra prebiótica.",en:"Think DIGESTION: enzymes that help break food down, with prebiotic fibre."}},
  biotic:{h:"dermalbiotic-probiotic-40-billion-with-prebiotics",n:"Dermabiotic",f:{es:"cápsula vegetal",en:"vegetable capsule"},p:30,
    q:{es:"Cuatro cepas: La-14, Bl-04, Lp-115 y Lpc-37. 40.000 millones de UFC, con FOS 24 mg.",en:"Four strains: La-14, Bl-04, Lp-115 and Lpc-37. 40 billion CFU, with FOS 24 mg."},
    w:{es:"Piensa en MICROBIOMA: si lo que te interesa son los microorganismos beneficiosos, no las enzimas.",en:"Think MICROBIOME: when beneficial micro-organisms are the point, not the enzymes."}},
  detox:{h:"clear-skin-detox-liver-support",n:"Clear Skin Detox",f:{es:"60 cápsulas",en:"60 capsules"},p:25,
    q:{es:"Cúrcuma, remolacha, diente de león, alcachofa, jengibre y cardo mariano.",en:"Turmeric, beet, dandelion, artichoke, ginger and milk thistle."},
    w:{es:"Apoyo enfocado al hígado, que participa en el metabolismo normal.",en:"Liver-focused support; the liver takes part in normal metabolism."}},
  sleep:{h:"beauty-sleep-formula",n:"Beauty Sleep Formula",f:{es:"60 cápsulas",en:"60 capsules"},p:25,gelatina:true,
    q:{es:"Valeriana 150 mg, manzanilla 100 mg, GABA 100 mg, L-triptófano, melisa, pasiflora y melatonina 2 mg.",en:"Valerian 150 mg, chamomile 100 mg, GABA 100 mg, L-tryptophan, lemon balm, passion flower and melatonin 2 mg."},
    w:{es:"El descanso como parte de la rutina, no como lo que sobra del día.",en:"Rest as part of the routine, not the leftover of the day."}},
  fuel:{h:"skin-fuel-creatine-hydration-powder",n:"Skin Fuel · Creatine Hydration",f:{es:"polvo",en:"powder"},p:40,
    q:{es:"Creatina monohidrato con magnesio, sodio y potasio.",en:"Creatine monohydrate with magnesium, sodium and potassium."},
    w:{es:"Para una vida activa: la creatina apoya la energía muscular y los electrolitos, la hidratación.",en:"For an active life: creatine supports muscular energy and the electrolytes, hydration."}},
  jolt:{h:"dermajolt-energy-powder-cotton-candy",n:"DERMAJOLT",f:{es:"polvo · Cotton Candy o Strawberry Shortcake",en:"powder · Cotton Candy or Strawberry Shortcake"},p:35,cafeina:true,
    q:{es:"Cafeína con L-teanina, sin azúcar.",en:"Caffeine with L-theanine, sugar free."},
    w:{es:"Energía y foco para el día que lo pide. Lleva cafeína.",en:"Energy and focus for the day that asks for it. Contains caffeine."}}
};

/* ---------------------------------------------------------------------------
   Flujo: objetivos (varios) -> tres preguntas sobre ti -> MUST HAVE y sugeridos.

   El MUST HAVE es la formula principal de cada objetivo que elegiste. Lo
   sugerido es lo que la acompana. Se separan porque no es lo mismo: una lista
   plana de seis productos no es un consejo, es un escaparate.

   Las preguntas sobre ti NO son de salud. Son tres: que tomas ya (para no
   repetirte nutrientes), como prefieres tomarlo y que prefieres evitar. Con eso
   se personaliza sin preguntar por enfermedades, que es donde esto dejaria de
   ser una guia de producto.
--------------------------------------------------------------------------- */

/* objetivo -> [principal, ...acompanantes] */
var OBJ={
  mineral:{es:{t:"Nutrición fundacional",d:"Minerales y oligoelementos"},en:{t:"Foundational nutrition",d:"Minerals and trace elements"},r:["fulvic","hsn"]},
  hsn:{es:{t:"Pelo, piel y uñas",d:"Los micronutrientes de siempre"},en:{t:"Hair, skin and nails",d:"The classic micronutrients"},r:["hsn","fulvic"]},
  verde:{es:{t:"Más variedad vegetal",d:"Para una dieta con poco verde"},en:{t:"More plant variety",d:"For a diet short on greens"},r:["greens","fulvic"]},
  congest:{es:{t:"Piel de aspecto desigual",d:"Apoyo nutricional diario"},en:{t:"Uneven-looking skin",d:"Everyday nutritional support"},r:["blemish","detox"]},
  firmeza:{es:{t:"Aspecto de firmeza y resiliencia",d:"El bloque de colágeno"},en:{t:"Look of firmness and resilience",d:"The collagen block"},r:["colbuild","colrec"]},
  edad:{es:{t:"Envejecimiento saludable",d:"Glicación y antioxidantes"},en:{t:"Healthy ageing",d:"Glycation and antioxidants"},r:["glyco","resv"]},
  digestion:{es:{t:"Digestión",d:"Enzimas y fibra prebiótica"},en:{t:"Digestion",d:"Enzymes and prebiotic fibre"},r:["biome","fulvic"]},
  microbioma:{es:{t:"Microbioma",d:"Cepas probióticas"},en:{t:"Microbiome",d:"Probiotic strains"},r:["biotic","biome"]},
  higado:{es:{t:"Apoyo hepático",d:"Cardo mariano y cúrcuma"},en:{t:"Liver support",d:"Milk thistle and turmeric"},r:["detox","greens"]},
  descanso:{es:{t:"Descanso",d:"Apoyo al descanso"},en:{t:"Rest",d:"Sleep support"},r:["sleep","fulvic"]},
  activo:{es:{t:"Vida activa",d:"Entreno e hidratación"},en:{t:"Active life",d:"Training and hydration"},r:["fuel","peptides"]},
  energia:{es:{t:"Energía y foco",d:"Para el día largo"},en:{t:"Energy and focus",d:"For the long day"},r:["jolt","fuel"]}
};
var MAX_OBJ=3;

var Q=[
 {id:"objetivos",multi:true,
  es:{t:"¿Qué quieres trabajar?",s:"Elige hasta tres. Puedes marcar varios."},
  en:{t:"What do you want to work on?",s:"Pick up to three. You can choose more than one."}},

 {id:"yatomas",es:{t:"¿Tomas ya algún suplemento?",s:"Para no repetirte nutrientes que ya llevas."},
             en:{t:"Are you already taking supplements?",s:"So we don't double up on nutrients you already get."},
  opts:[
   {v:"nada",es:{t:"Nada por ahora",d:""},en:{t:"Nothing right now",d:""}},
   {v:"colageno",es:{t:"Un colágeno",d:"En polvo o en cápsula"},en:{t:"A collagen",d:"Powder or capsule"}},
   {v:"multi",es:{t:"Un multivitamínico o minerales",d:""},en:{t:"A multivitamin or minerals",d:""}},
   {v:"varios",es:{t:"Varios",d:"Prefiero lo mínimo"},en:{t:"Several",d:"I'd rather keep it minimal"}}]},

 {id:"formato",es:{t:"¿Cómo prefieres tomarlo?",s:"Algunas fórmulas existen en los dos formatos."},
            en:{t:"How would you rather take it?",s:"Some formulas exist in both formats."},
  opts:[
   {v:"caps",es:{t:"Cápsulas",d:"Se toma y se acabó"},en:{t:"Capsules",d:"Swallow and done"}},
   {v:"polvo",es:{t:"Polvo o bebida",d:"En el café, el agua o el batido"},en:{t:"Powder or drink",d:"Into coffee, water or a smoothie"}},
   {v:"igual",es:{t:"Me da igual",d:"Elige tú por mí"},en:{t:"No preference",d:"You choose for me"}}]},

 {id:"evitar",es:{t:"¿Algo que prefieras evitar?",s:""},en:{t:"Anything you'd rather avoid?",s:""},
  opts:[
   {v:"nada",es:{t:"Nada en particular",d:""},en:{t:"Nothing in particular",d:""}},
   {v:"cafeina",es:{t:"Cafeína",d:"Fuera DERMAJOLT"},en:{t:"Caffeine",d:"Rules out DERMAJOLT"}},
   {v:"gelatina",es:{t:"Gelatina",d:"Fuera las cápsulas de gelatina"},en:{t:"Gelatin",d:"Rules out gelatin capsules"}}]}
];

var T={
 es:{step:"Paso",of:"de",back:"← Volver",restart:"Empezar de nuevo",continuar:"Continuar",
     elegidos:"elegidos",maxAviso:"Puedes elegir hasta tres.",
     kicker:"Tu selección",title:"Lo que encaja con lo que buscas.",
     must:"Imprescindibles",mustSub:"La fórmula principal de cada objetivo que has elegido.",
     sug:"Además puedes sumar",sugSub:"Acompañan a lo de arriba. Ni son obligatorios ni hay que llevarlos todos.",
     quees:"Qué es",parque:"Por qué este",
     total:"Total de lo marcado",cart:"Añadir lo marcado al carrito",oos:"Sin stock",
     forkT:"¿Beauty Biome o Dermabiotic?",
     forkD:"Las dos trabajan el intestino por caminos distintos. Elige por tu objetivo, no por el número de UFC: normalmente no hacen falta las dos. Las fibras fermentables pueden dar gases o hinchazón.",
     nota:"Se abre el carrito con lo que dejes marcado. Lo que esté sin stock no se incluye.",
     yaColageno:"Como ya tomas un colágeno, lo hemos sacado de los imprescindibles para que no dupliques.",
     yaMulti:"Como ya tomas un multivitamínico o minerales, hemos bajado la base mineral a sugerencia.",
     yaVarios:"Como ya tomas varios, dejamos solo lo principal de cada objetivo.",
     exCafeina:"DERMAJOLT es la fórmula de energía de la línea y lleva cafeína. Como prefieres evitarla, te proponemos Skin Fuel, que apoya la energía por otra vía.",
     exGelatina:"La única fórmula de descanso de la línea, Beauty Sleep, va en cápsula de gelatina. Como prefieres evitarla, no hay alternativa de descanso en el catálogo.",
     sinPrecios:"No se pudieron cargar los precios. La selección es correcta; recarga para añadirla al carrito."},
 en:{step:"Step",of:"of",back:"← Back",restart:"Start over",continuar:"Continue",
     elegidos:"selected",maxAviso:"You can pick up to three.",
     kicker:"Your selection",title:"What fits what you're after.",
     must:"Must have",mustSub:"The primary formula for each goal you picked.",
     sug:"You could also add",sugSub:"These go alongside the above. Not required, and you don't need all of them.",
     quees:"What it is",parque:"Why this one",
     total:"Total for what's ticked",cart:"Add ticked items to cart",oos:"Out of stock",
     forkT:"Beauty Biome or Dermabiotic?",
     forkD:"Both work on the gut, by different routes. Choose by your goal, not by the highest CFU count: you generally don't need both. Fermentable fibres may cause gas or bloating.",
     nota:"Opens the cart with whatever you leave ticked. Out-of-stock items are not included.",
     yaColageno:"Since you already take a collagen, we've moved it out of the must-haves so you don't double up.",
     yaMulti:"Since you already take a multivitamin or minerals, we've moved the mineral base down to a suggestion.",
     yaVarios:"Since you already take several, we've kept only the primary formula for each goal.",
     exCafeina:"DERMAJOLT is the line's energy formula and contains caffeine. Since you'd rather avoid it, we're suggesting Skin Fuel, which supports energy by a different route.",
     exGelatina:"The line's only rest formula, Beauty Sleep, comes in a gelatin capsule. Since you'd rather avoid it, there is no rest alternative in the catalogue.",
     sinPrecios:"Prices could not be loaded. The selection is correct; reload to add it to the cart."}
};

var lang="es"; try{lang=localStorage.getItem("tts_lang")||"es";}catch(e){}
var step=0, answers={objetivos:[]}, must=[], sug=[], excluido={}, vivo=false, motivos=[];

function loadLive(){
  fetch("/products.json?limit=250",{headers:{Accept:"application/json"}})
    .then(function(r){if(!r.ok)throw 0;return r.json();})
    .then(function(j){
      var porHandle={}; (j.products||[]).forEach(function(p){porHandle[p.handle]=p;});
      Object.keys(S).forEach(function(k){
        var p=porHandle[S[k].h]; if(!p)return;
        var vs=(p.variants||[]).filter(function(x){return x.available;});
        if(!vs.length) vs=(p.variants||[]).slice(0,1);
        var v=vs[0]||{};
        if(v.price)S[k].p=Math.round(parseFloat(v.price));
        if(v.id)S[k].vid=String(v.id);
        S[k].avail=!!v.available;
      });
      vivo=true; if(must.length||sug.length)pintaResultado();
    })
    .catch(function(){});
}

/* ---------- decision ---------- */
function esColageno(k){ return k==="colbuild"||k==="colrec"||k==="peptides"; }

function decidir(a){
  motivos=[];
  var principales=[], acomp=[];
  a.objetivos.forEach(function(o){
    var r=OBJ[o].r.slice();
    /* Formato: solo se cambia donde hay equivalente real del mismo objetivo. El
       colageno existe en capsula y en polvo; H.S.N. y SkinGreens no son la misma
       cosa en dos formatos, son dos objetivos distintos. */
    if(a.formato==="polvo") r=r.map(function(k){return esColageno(k)?"peptides":k;});
    else if(a.formato==="caps") r=r.map(function(k){return k==="peptides"?"colbuild":k;});
    principales.push(r[0]);
    r.slice(1).forEach(function(k){acomp.push(k);});
  });

  /* Exclusiones */
  if(a.evitar==="cafeina"){
    if(principales.indexOf("jolt")>-1||acomp.indexOf("jolt")>-1) motivos.push("exCafeina");
    principales=principales.map(function(k){return k==="jolt"?"fuel":k;});
    acomp=acomp.map(function(k){return k==="jolt"?"fuel":k;});
  }
  if(a.evitar==="gelatina"){
    if(principales.indexOf("sleep")>-1) motivos.push("exGelatina");
    principales=principales.filter(function(k){return !S[k].gelatina;});
    acomp=acomp.filter(function(k){return !S[k].gelatina;});
  }

  /* Lo que ya toma: no se le repite */
  if(a.yatomas==="colageno"){
    var habia=principales.some(esColageno);
    acomp=acomp.concat(principales.filter(esColageno));
    principales=principales.filter(function(k){return !esColageno(k);});
    if(habia) motivos.push("yaColageno");
  }
  if(a.yatomas==="multi"){
    var teniaBase=principales.indexOf("fulvic")>-1||principales.indexOf("hsn")>-1;
    acomp=acomp.concat(principales.filter(function(k){return k==="fulvic"||k==="hsn";}));
    principales=principales.filter(function(k){return k!=="fulvic"&&k!=="hsn";});
    if(teniaBase) motivos.push("yaMulti");
  }

  var vistos={},M=[];
  principales.forEach(function(k){ if(S[k]&&!vistos[k]){vistos[k]=1;M.push(k);} });
  var G=[];
  /* Con "varios" no se sugiere nada extra: ya lleva bastante. */
  if(a.yatomas!=="varios"){
    acomp.forEach(function(k){ if(S[k]&&!vistos[k]){vistos[k]=1;G.push(k);} });
  } else if(M.length) motivos.push("yaVarios");
  /* Si todo cayo por exclusiones, la base mineral sostiene la respuesta. */
  if(!M.length && !G.length && !vistos.fulvic) G.push("fulvic");
  return {must:M, sug:G.slice(0,4)};
}

/* ---------- wizard ---------- */
function pintaPaso(){
  var q=Q[step], L=q[lang];
  var prog=document.getElementById("progress"); prog.innerHTML="";
  Q.forEach(function(_,i){var d=document.createElement("span");d.className="dot"+(i<=step?" done":"");prog.appendChild(d);});
  document.getElementById("stepno").textContent=T[lang].step+" "+(step+1)+" "+T[lang].of+" "+Q.length;
  document.getElementById("qtitle").textContent=L.t;
  document.getElementById("qsub").textContent=L.s||"";
  var box=document.getElementById("opts"); box.innerHTML="";
  var cont=document.getElementById("contBtn");

  if(q.multi){
    Object.keys(OBJ).forEach(function(o){
      var b=document.createElement("button"); b.type="button";
      b.className="opt"+(answers.objetivos.indexOf(o)>-1?" sel":"");
      b.innerHTML='<span class="ot"></span><span class="od"></span>';
      b.querySelector(".ot").textContent=OBJ[o][lang].t;
      b.querySelector(".od").textContent=OBJ[o][lang].d;
      b.onclick=function(){
        var i=answers.objetivos.indexOf(o);
        if(i>-1) answers.objetivos.splice(i,1);
        else if(answers.objetivos.length<MAX_OBJ) answers.objetivos.push(o);
        pintaPaso();
      };
      box.appendChild(b);
    });
    cont.hidden=false;
    cont.disabled=answers.objetivos.length===0;
    cont.textContent=T[lang].continuar+(answers.objetivos.length?" ("+answers.objetivos.length+" "+T[lang].elegidos+")":"");
    cont.onclick=function(){ step++; pintaPaso(); };
  } else {
    cont.hidden=true;
    q.opts.forEach(function(o){
      var b=document.createElement("button"); b.className="opt"; b.type="button";
      b.innerHTML='<span class="ot"></span><span class="od"></span>';
      b.querySelector(".ot").textContent=o[lang].t;
      b.querySelector(".od").textContent=o[lang].d||"";
      b.onclick=function(){
        answers[q.id]=o.v; step++;
        if(step<Q.length) pintaPaso();
        else { var d=decidir(answers); must=d.must; sug=d.sug; pintaResultado(); }
      };
      box.appendChild(b);
    });
  }
  var back=document.getElementById("backBtn");
  back.hidden = step===0; back.textContent=T[lang].back;
  back.onclick=function(){ if(step>0){step--; pintaPaso();} };
}

/* ---------- resultado ---------- */
function ficha(k,rol){
  var s=S[k], L=T[lang];
  var card=document.createElement("div"); card.className="sup"+(s.avail===false?" oos":"");
  var marca=document.createElement("label");
  var chk=document.createElement("input"); chk.type="checkbox"; chk.className="chk";
  chk.checked=!excluido[k]; chk.disabled=s.avail===false;
  chk.onchange=function(){ excluido[k]=!chk.checked; total(); };
  marca.appendChild(chk);
  var cuerpo=document.createElement("div");
  cuerpo.innerHTML='<h3 class="serif"></h3><p class="fmt"></p>'+
    '<p class="bloque"><b></b> <span class="qe"></span></p>'+
    '<p class="bloque"><b></b> <span class="pq"></span></p>';
  cuerpo.querySelector("h3").textContent=s.n;
  cuerpo.querySelector(".fmt").textContent=s.f[lang]+(s.avail===false?" · "+L.oos:"");
  cuerpo.querySelectorAll("b")[0].textContent=L.quees+":";
  cuerpo.querySelectorAll("b")[1].textContent=L.parque+":";
  cuerpo.querySelector(".qe").textContent=s.q[lang];
  cuerpo.querySelector(".pq").textContent=s.w[lang];
  var pr=document.createElement("span"); pr.className="precio"; pr.textContent="$"+s.p;
  card.appendChild(marca); card.appendChild(cuerpo); card.appendChild(pr);
  return card;
}

function pintaResultado(){
  document.getElementById("wizard").hidden=true;
  var R=document.getElementById("result"); R.hidden=false;
  var L=T[lang];
  document.getElementById("rkicker").textContent=L.kicker;
  document.getElementById("rtitle").textContent=L.title;
  document.getElementById("rsub").textContent=
    answers.objetivos.map(function(o){return OBJ[o][lang].t;}).join(" · ");

  var mv=document.getElementById("motivo");
  mv.innerHTML=""; mv.hidden=!motivos.length;
  motivos.forEach(function(m){ var p=document.createElement("p"); p.textContent=L[m]; mv.appendChild(p); });

  var bM=document.getElementById("bloqueMust");
  bM.hidden=!must.length;
  document.getElementById("mustT").textContent=L.must;
  document.getElementById("mustS").textContent=L.mustSub;
  var lm=document.getElementById("listaMust"); lm.innerHTML="";
  must.forEach(function(k){ lm.appendChild(ficha(k)); });

  var bS=document.getElementById("bloqueSug");
  bS.hidden=!sug.length;
  document.getElementById("sugT").textContent=L.sug;
  document.getElementById("sugS").textContent=L.sugSub;
  var ls=document.getElementById("listaSug"); ls.innerHTML="";
  sug.forEach(function(k){ ls.appendChild(ficha(k)); });

  var fork=document.getElementById("fork");
  var todos=must.concat(sug);
  var hayGut = todos.indexOf("biome")>-1 || todos.indexOf("biotic")>-1;
  fork.hidden=!hayGut;
  if(hayGut){
    fork.querySelector(".ft").textContent=L.forkT;
    fork.querySelector(".fd").textContent=L.forkD;
    fork.querySelector(".fa").textContent="Beauty Biome · "+S.biome.w[lang];
    fork.querySelector(".fb").textContent="Dermabiotic · "+S.biotic.w[lang];
  }
  document.getElementById("nota").textContent=L.nota;
  document.getElementById("cartBtn").textContent=L.cart;
  document.getElementById("restartBtn").textContent=L.restart;
  total();
}
function activos(){
  return must.concat(sug).filter(function(k){return !excluido[k] && S[k].avail!==false;});
}
function total(){
  var t=0; activos().forEach(function(k){t+=S[k].p;});
  document.getElementById("totalLbl").textContent=T[lang].total;
  document.getElementById("totalVal").textContent="$"+t;
}
function alCarrito(){
  var items=activos().filter(function(k){return S[k].vid;})
                     .map(function(k){return {id:S[k].vid,quantity:1};});
  if(!items.length){ alert(T[lang].sinPrecios); return; }
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({items:items})})
    .then(function(){ location.href="/cart"; })
    .catch(function(){ alert(T[lang].sinPrecios); });
}

function setLang(l){ lang=l; if(must.length||sug.length)pintaResultado(); else pintaPaso(); }
document.addEventListener("tts:idioma",function(e){ setLang(e.detail.lang); });

document.addEventListener("DOMContentLoaded",function(){
  loadLive(); pintaPaso();
  document.getElementById("cartBtn").onclick=alCarrito;
  document.getElementById("restartBtn").onclick=function(){
    step=0; answers={objetivos:[]}; must=[]; sug=[]; excluido={}; motivos=[];
    document.getElementById("result").hidden=true;
    document.getElementById("wizard").hidden=false; pintaPaso();
  };
});
